export default "fe582b96059d4284.svg"